import { Car } from '@/commonTypes';
import { StatusRow } from '../../StatusRow/StatusRow';
import styles from '../../styles.module.css';
// import ReplaceTextFunction from '@/functions/ReplaceTextFunction';
import { useLayoutContext } from '@/context/LayoutContext';
import NoneViolationDetails from './NonViolationDetails';

type PlateDetailsProps = {
  plate: Car;
  footerTitle?: string;
};

export default function PlateDetails({ plate, footerTitle = 'بدهی این پلاک' }: PlateDetailsProps) {
  const { priceSymbol } = useLayoutContext();
  return (
    <div
    // className={styles.detail}
    >
      <NoneViolationDetails response={plate?.rows} type="" />

      <div className={styles.detailFoot}>
        <span className={styles.detailFootLabel}>{footerTitle}</span>

        <span className={styles.detailFootValue} style={{ color: 'red' }}>
          {plate?.debt}

          <span className={styles.detailFootUnit}>{priceSymbol}</span>
        </span>
      </div>
    </div>
  );
}
